<app-full-page-message
  *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
  *ngIf="!businessId || businessId.length <5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="!localService.isServiceProviderBlocked(false) && localService.languageContent && localService.languageContent.relationship">
    <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
      [businesses]="localService.loggedMember.businesses"></app-business-deductive>
    <span style="display:none;">
      <i class="material-icons on_language_changed" style="float:left;" (click)="onLoad()">replay_circle_filled</i>
    </span>
    <div class="banner center" style="max-width:1000px;" *ngIf="wrapperInitialization">
      <div class="row freeze_height">
        <div class="col-sm-6">
          <label style="font-weight: normal; margin-left: 25px;" *ngIf="localService.basicParams.interactionType == 1">
            <input type="checkbox" [checked]="isShowRemovedRelation" (change)="onToggleCheckbox(1)" />
            <span>{{localService.languageContent.relationship.show_removed_relation}}</span>
          </label>
          <app-selected-business-title *ngIf="localService.basicParams.interactionType == 2"
            [businessId]="businessId"></app-selected-business-title>
        </div>
        <div class="col-sm-6">
          <ngx-select *ngIf="wrapperInitialization.roles" [(ngModel)]="wrapperInitialization.selectedRole"
            [optionValueField]="'key'" [optionTextField]="'value'" [items]="wrapperInitialization.roles"
            [noAutoComplete]="true" (select)="onSelectDropDown(1)">
          </ngx-select>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <div class="row row_header freeze_height">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-3">
                {{localService.languageContent.relationship.relationship_number}}
              </div>
              <div class="col-5">
                {{localService.basicParams.interactionType == 1 ? localService.languageContent.relationship.seller_name
                :
                localService.languageContent.relationship.customer_name}}
              </div>
              <div class="col-4" style="text-align:right">
                {{localService.languageContent.relationship.since}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-7">
                {{localService.languageContent.relationship.role}}
              </div>
              <div class="col-5" style="text-align:right;">
                {{localService.languageContent.relationship.credits}}
              </div>
            </div>
          </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
          <div class="row styled_row" *ngFor="let item of wrapperInitialization.contents.items">
            <div class="col-sm-6">
              <div class="row">
                <div class="col-3">
                  <button type="button" class="button_icon button_icon_color delete_icon cancel"
                    [disabled]="item.v6.indexOf('-') > -1" (click)="onRemoveOrUndo(item.key)"
                    *ngIf="localService.basicParams.interactionType == 1">
                    {{isShowRemovedRelation ? 'settings_backup_restore' : 'cancel'}}
                  </button>
                  <span class="en text_align">{{item.v3}}</span>
                  <button class="button_icon button_icon_color icon_adjust" [disabled]="item.v9 != '2'"
                    (click)="onAction(1,item.v8)">edit_location</button>
                </div>
                <div class="col-5 button">
                  <i class="material-icons icon_adjust" style="color:gray;">{{onGetIcon(item.v4,item.v9)}}</i>
                  <span class="text_align"
                    (click)="localService.showSummary(onGetSummaryParentId(item.v8,item.v5), onGetSummaryType(item.v4,item.v9))"
                    [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
                </div>
                <div class="col-4 en text_align" style="text-align:right">
                  {{item.v7 | date: 'dd-MMM-yyyy'}}
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <div class="col-7">
                  <button type="button" class="button_icon button_icon_color" style="top:5px;"
                    (click)="onEdit(item.key,1)"
                    *ngIf="localService.basicParams.interactionType != 1 && item.v4 != '4' && localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
                    mode_edit
                  </button>
                  <span class="text_align_2">{{getRole(item.v4)}}</span>
                  <i *ngIf="item.v4 != '3' && item.v4 != '4'" class="material-icons paid-icon"
                    [ngStyle]="{'color' : item.v10 == '1' ? 'green' : 'red'}">paid</i>
                </div>
                <div class="col-5" style="text-align:right;">
                  <button type="button" class="button_icon button_icon_color" (click)="onEdit(item.key,2)"
                    *ngIf="localService.basicParams.interactionType != 1" style="top:5px;">
                    mode_edit
                  </button>
                  <span class="en text_align_2">{{item.v6 | number: '1.2-2'}}</span>
                  <button type="button" class="button_icon button_icon_color action_icon_right" style="top:5px;"
                    (click)="onShowHistory(item.key)">
                    history
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-paging *ngIf="wrapperInitialization" [paging]="wrapperInitialization.contents.paging"
      (onPagingRefreshed)="onLoadItems()"></app-paging>
  </div>
</div>